<template>
  <div class="container mt-5">
    <h3 class="text-center">{{ transPeralbaPro.item1233 }}</h3>
    <p class="text-center">
      {{ transPeralbaPro.item1234 }}
    </p>

    <div
      class="row justify-content-center flex-column align-content-center	"
      v-if="customers.length"
    >
      <!-- Cuenta 1 -->
      <div class="col-md-6 mb-3" v-for="(customer, key) in customers">
        <div class="card shadow">
          <div class="card-body text-center">
            <h5 class="card-title">{{ customer.name }}</h5>
            <p class="card-text">
              <strong>{{ transPeralbaPro.item46 }}: </strong>{{ customer.code }}
            </p>
            <p class="card-text">
              <strong>{{ transPeralbaPro.item113 }}: </strong>{{ customer.nif }}
            </p>
            <button
              class="btn btn-per-dark w-100"
              :disabled="loading"
              @click="login($event, customer)"
            >
              {{ transPeralbaPro.item1235 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HTTP from "../../../../services/http";
export default {
  props: ["transPeralbaPro", "customers", "currentId", "senderId", "platform", "osVersion", "appVersion", "routeMultiLogin"],
  data() {
    return {
      errors: [],
      loading: false,
    };
  },
  methods: {
    login(e, customer) {
      e.preventDefault();
      this.errors = [];
      if (this.loading) return;
      this.loading = true;
      const csrf = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");

      HTTP.post(this.routeMultiLogin, {
        currentId: this.currentId,
        customerId: customer.id,
        sender_id: this.senderId,
        platform: this.platform,
        os_version: this.osVersion,
        app_version: this.appVersion,
        _token: csrf,
      })
        .then((r) => {
          if (r.data.status != 2) {
            window.location.href = r.data.url;
          } else {
            this.errors.push(r.data);
          }
        })
        .catch((e) => {
          this.errors.push(e.response.data);
          this.loading = false;
        });
    },
  },
};
</script>
